import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Tag, MapPin } from "lucide-react";

/** Encart discret « Bons plans du moment » : 4 offres locales RÉELLES tirées
 *  au hasard à chaque chargement, pour mettre en avant les partenaires. */
export default function PressOffers({ limit = 4, testId = "press-offers", track = false, channel = "press", city = "" }) {
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get("/offers?status=published&limit=30")
      .then((r) => {
        if (!alive) return;
        const list = Array.isArray(r.data) ? r.data.slice() : [];
        // Mélange de Fisher-Yates pour une sélection aléatoire à chaque chargement
        for (let i = list.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [list[i], list[j]] = [list[j], list[i]];
        }
        // Priorise les offres de la même commune que le contenu, puis complète
        let ordered = list;
        const norm = (city || "").trim().toLowerCase();
        if (norm) {
          const local = list.filter((o) => (o.city || "").trim().toLowerCase() === norm);
          const others = list.filter((o) => (o.city || "").trim().toLowerCase() !== norm);
          ordered = [...local, ...others];
        }
        const picked = ordered.slice(0, limit);
        setOffers(picked);
        if (track && picked.length) {
          const ids = [...new Set(picked.map((o) => o.business_id).filter(Boolean))];
          if (ids.length) api.post("/track/editorial-placement", { business_ids: ids, channel }).catch(() => {});
        }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [limit, track, channel, city]);

  if (!offers.length) return null;

  return (
    <section className="mt-12 pt-8 border-t border-slate-100" data-testid={testId}>
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-xl font-bold text-slate-900 flex items-center gap-2">
          <Tag size={18} className="text-[#E05638]" /> Bons plans du moment
        </h2>
        <span className="text-[10px] font-semibold uppercase tracking-widest text-slate-400">Partenaires</span>
      </div>
      <p className="mt-1 text-sm text-slate-500">Quelques offres locales à ne pas manquer près de chez vous.</p>

      <div className="mt-4 grid grid-cols-2 lg:grid-cols-4 gap-3">
        {offers.map((o) => {
          const img = o.image || (o.images && o.images[0]) || null;
          return (
            <Link key={o.id} to={`/offre/${o.id}`} data-testid={`press-offer-${o.id}`}
                  className="group rounded-xl border border-slate-200 bg-white overflow-hidden hover:border-[#E05638] transition-colors">
              <div className="aspect-[16/10] bg-slate-100 overflow-hidden">
                {img && <img src={img} alt={o.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />}
              </div>
              <div className="p-2.5">
                {o.discount && <span className="inline-block text-[11px] font-extrabold text-white bg-rose-500 rounded-full px-2 py-0.5">{o.discount}</span>}
                <div className="mt-1 font-semibold text-slate-900 text-sm leading-tight line-clamp-2">{o.title}</div>
                {o.city && <div className="mt-1 text-xs text-slate-500 inline-flex items-center gap-1"><MapPin size={11} /> {o.city}</div>}
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
